import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "@/components/CartDrawer";
import CookieBanner from "@/components/CookieBanner";

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar />
            <main className="flex-1" data-testid="main-content">
                {children}
            </main>
            <Footer />
            <CartDrawer />
            <CookieBanner />
        </div>
    );
};

export default Layout;
